import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { LocationItemTypeEnum } from '#src/app/pages/search/shared/types';

import { useSearchActions } from '../../../useSearchActions';
import { useSearchState } from '../../../useSearchState';

type Result = ModelHookResult<
	undefined,
	{
		selectLocation: (value: string, type: LocationItemTypeEnum) => void;
	}
>;

export function useSelectLocation(): Result {
	const track = useTracking();
	const state = useSearchState();
	const actions = useSearchActions();

	return {
		actions: {
			selectLocation: useCallback(
				(value: string, type: LocationItemTypeEnum) => {
					void track('search', {
						context: 'location_filter',
						location_value: value,
						location_type: type,
						q: state.query || '',
					});
					if (type === 'country') {
						actions.setLocationCountry(value);
					}
					if (type === 'city') {
						actions.setLocationCity(value);
					}
				},
				[track, state.query, actions],
			),
		},
	};
}
